import { GlButton, GlLink, GlSprintf, GlAvatarLink, GlAvatar, GlAvatarsInline, GlAnimatedChevronRightDownIcon } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { uniqBy } from 'lodash-es';
import { s__ } from '~/locale';
import TimeAgoTooltip from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/time_ago_tooltip.vue?vue3';
export default {
    name: 'ToggleRepliesWidget',
    i18n: {
        collapseReplies: s__('Notes|Collapse replies'),
        expandReplies: s__('Notes|Expand replies'),
        lastReplyBy: s__('Notes|Last reply by %{name}')
    },
    components: {
        GlButton,
        GlLink,
        GlSprintf,
        GlAvatarLink,
        GlAvatar,
        GlAvatarsInline,
        GlAnimatedChevronRightDownIcon,
        TimeAgoTooltip
    },
    props: {
        collapsed: {
            type: Boolean,
            required: true
        },
        replies: {
            type: Array,
            required: true
        },
        tag: {
            type: String,
            default: 'li',
            required: false
        }
    },
    emits: [
        'toggle'
    ],
    computed: {
        lastReply () {
            return this.replies[this.replies.length - 1];
        },
        uniqueAuthors () {
            const authors = this.replies.map((reply)=>reply.author || {});
            return uniqBy(authors, 'username');
        },
        buttonLabel () {
            return this.collapsed ? this.$options.i18n.expandReplies : this.$options.i18n.collapseReplies;
        },
        ariaState () {
            return String(!this.collapsed);
        }
    },
    methods: {
        toggle () {
            this.$refs.toggle.$el.focus();
            this.$emit('toggle');
        }
    }
};
